import { Avatar as AvatarBase, AVATAR_SIZE_PX } from './Avatar';
import { AvatarLabelGroup } from './AvatarLabelGroup';

export const Avatar = Object.assign(AvatarBase, {
    LabelGroup: AvatarLabelGroup,
    SIZES: AVATAR_SIZE_PX,
});
export type { AvatarProps, AvatarSize } from './Avatar';
export type { AvatarLabelGroupProps } from './AvatarLabelGroup';
